import React, { Component } from "react";
import { connect } from "react-redux";

import { addFlashMessage } from "../../../store/actions/flashMessage";

import FlashMessageItem from "./FlashMessageItem";
class FlashMessage extends Component {
  render() {
    return this.props.flashMessage.messages.map(
      ({ title, type, messages }, i) => (
        <FlashMessageItem
          key={i}
          type={type}
          title={title}
          messages={messages}
          style={this.props.style}
        />
      )
    );
  }
}

const mapStateToProps = ({ flashMessage }) => {
  return {
    flashMessage
  };
};

const mapDispatchToProps = {
  addFlashMessage
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlashMessage);



// WEBPACK FOOTER //
// ./src/components/shared/FlashMessage/index.js